import { createFragmentContainer, graphql } from 'react-relay/legacy';

// components
import { SbSharedRefineMenuMultiSelectSearch } from '../SbSharedRefineMenuMultiSelect/SbSharedRefineMenuMultiSelectSearch';

const SbSharedRefineMenuFilterStoneComponent = props => (
    <SbSharedRefineMenuMultiSelectSearch {...props} />
);

export const SbSharedRefineMenuFilterStone = createFragmentContainer(
    SbSharedRefineMenuFilterStoneComponent,
    {
        viewer: graphql`
            fragment SbSharedRefineMenuFilterStone_viewer on Viewer {
                ...SbSharedRefineMenuMultiSelectSearch_viewer
            }
        `,
        itemSearch: graphql`
            fragment SbSharedRefineMenuFilterStone_itemSearch on ItemSearchQueryConnection {
                ...SbSharedRefineMenuMultiSelectSearch_itemSearch
            }
        `,
    }
);
